import * as model from './model.js';
import Swiper from 'swiper/bundle';
import 'lity/dist/lity.css';
import 'lity/dist/lity.js';
import 'swiper/swiper-bundle.css';
import Main from './views/main.js';

const option = {
  loop: true,
  effect: 'fade', //フェードのエフェクト
  speed: 1000,
  autoplay: {
    delay: 3000, //3秒後に次の画像へ
  },
};

const swiper = new Swiper('.swiper', option);

const setHeight = function () {
  const targetBlock = document.querySelector('.campaign__detailInfo--box');
  const plus = document.querySelector('.btn__plus');
  const minus = document.querySelector('.btn__minus');
  // plus.classList.toggle('active');
  // plus.classList.toggle('nonactive');
  // minus.classList.toggle('nonactive');
  // minus.classList.toggle('active');
  // targetBlock.classList.toggle('dropDown');
};

const pointEl = document.querySelector('.products');
const el = document.querySelector('.followingBnr');
el.classList.add('bnrHidden');

const bnrDown = function (entries) {
  const [entry] = entries;
  console.log(entry);
  if (entry.isIntersecting) {
    console.log('Hi');
    el.classList.remove('bnrHidden');
  } else {
    el.classList.add('bnrHidden');
  }
};

const bnrFollowStop = new IntersectionObserver(bnrDown, {
  root: null,
  threshold: 0,
});
// pointEl.forEach((point) => observer.observe(point));
bnrFollowStop.observe(pointEl);

// const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
// var smoothScrollType;
// if ('scrollBehavior' in document.documentElement.style) {
// } else {
//   smoothScrollType = oldTypeSmoothScroll;
// }
// for (let i = 0; i < smoothScrollTrigger.length; i++) {
//   smoothScrollTrigger[i].addEventListener('click', (e) => {
//     e.preventDefault();
//     let href = smoothScrollTrigger[i].getAttribute('href');
//     let targetElement = document.getElementById(href.replace('#', ''));
//     const rect = targetElement.getBoundingClientRect().top;
//     const offset = window.pageYOffset;
//     const gap = 60;
//     const target = rect + offset - gap;
//     window.scrollTo({
//       top: target,
//       behavior: 'smooth',
//     });
//   });
// }

/* scrollToのOptionsに対応していない場合 */
// function oldTypeSmoothScroll(e) {
//   e.preventDefault();
//   // スクロール速度の設定
//   var scrollSpeed = 300;
//   var timerStep = 20;
//   // 遷移先の要素
//   var pagelinkId = e.target.hash;
//   var pagelinkSection = document.querySelector(pagelinkId);
//   // スクロール先の位置
//   var scrollPosition = window.pageYOffset;
//   var sectionPosition = pagelinkSection.getBoundingClientRect().top;
//   var goalPosition = scrollPosition + sectionPosition;
//   // スクロール量
//   var scrollStep = sectionPosition / (scrollSpeed / timerStep);
//   var currentScroll = scrollPosition;

//   // スクロールの実行
//   var smoothScrollTimer = setInterval(function () {
//     // スクロール完了時
//     if (currentScroll >= goalPosition) {
//       // スクロール位置を完了位置に設定
//       window.scrollTo(0, goalPosition);
//       // タイマーのクリア
//       clearInterval(smoothScrollTimer);
//     } else {
//       currentScroll += scrollStep;
//       window.scrollTo(0, currentScroll);
//     }
//   }, timerStep);
// }

const bnr = document.querySelector('.followingBnr');
const getPosi = function () {
  let pcLeftWidth = document.querySelector('.pcLeft').clientWidth;
  let pcLpWidth = document.querySelector('.lpWrapper').clientWidth;
  const sumWidth = pcLeftWidth + pcLpWidth - 100;
  bnr.style.left = sumWidth + 'px';
};

if (
  (navigator.userAgent.indexOf('iPhone') > 0 &&
    navigator.userAgent.indexOf('iPad') == -1) ||
  navigator.userAgent.indexOf('iPod') > 0 ||
  navigator.userAgent.indexOf('Android') > 0
) {
  return;
} else {
  window.addEventListener('resize', getPosi);
}
const init = function () {
  getPosi();
  Main.addHandlerClick(setHeight);
};

init();
